<script>
  import {getContext} from 'svelte';
  import {Button} from '@px/button';
  import {PATHS} from '@/const/paths';
  import {fixLink$} from '@/store/lang';
  import CreateWithGoogle from '@/modules/register/componets/CreateWithGoogle.svelte';
  import lang from '../HomePage.lang';
  import {sd} from '@/da';

  const LG = getContext('LG');

  function handleGoogleClick() {
    sd.track('web_click', {$screen_name: 'home', $element_content: 'sign up with google'});
  }

  function handleEmailClick() {
    window.location.assign($fixLink$(PATHS.REGISTER.pathname));
  }
</script>

<style>
  .wrap :global(.primary) {
    padding: 0 48px;
    height: 64px !important;
    font-size: 18px !important;
  }
  @media screen and (max-width: 640px) {
    .wrap {
      flex-direction: column;
      width: 100%;
    }
    .google {
      margin-left: 0;
    }
  }
</style>

<div class="wrap df TW ">
  <Button class="fw2" type="primary" on:click={handleEmailClick}>{LG(lang.SignUpWithEmail)}</Button>
  <div class="google ml12" on:click={handleGoogleClick}>
    <CreateWithGoogle isShowOr={false} entrance="Register" />
  </div>
</div>
